import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import type { PipelineHistoryField } from '@repo/lakehouse-sdk';
import { Tag } from '@/components/tag';
import { historyValueText } from './historyView';
export const HistoryValue = t0 => {
  const $ = _c(11);
  const {
    field
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "4px",
      minWidth: "0px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      whiteSpace: "pre-wrap",
      overflowWrap: "anywhere"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== field) {
    t3 = historyValueText(field);
    $[2] = field;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Typography variant="subtitle2" sx={t2}>{t3}</Typography>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== field) {
    t5 = !field && <Tag content="Not present" variant="secondary" />;
    $[6] = field;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <Stack sx={t1}>{t4}{t5}</Stack>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};